import React from "react";
import OperationalLeasingAgreement from "./OperationalLeasingAgreement";
import ProductTerms from "./ProductTerms";
import TermsAndConditions from "./TermsAndConditions";
import UserTerms from "./UserTerms";

export type DocumentId =
  | "terms_conditions"
  | "user_terms"
  | "product_terms"
  | "operational_leasing_agreement";

type TermsOfUseProps = {
  activeDocument: DocumentId;
};

const documents: Record<DocumentId, React.ReactNode> = {
  terms_conditions: <TermsAndConditions />,
  user_terms: <UserTerms />,
  product_terms: <ProductTerms />,
  operational_leasing_agreement: <OperationalLeasingAgreement />,
};

const TermsOfUse: React.FC<TermsOfUseProps> = ({ activeDocument }) => {
  return <>{documents[activeDocument]}</>;
};

export default TermsOfUse;
